/**
 * LiveSyncBadge — tiny indicator showing "Live · synced Ns ago" + manual
 * refresh button. Works hand-in-hand with useSmartPolling.
 */
import React, { useEffect, useState } from 'react';
import { RefreshCw, Wifi } from 'lucide-react';

const formatAgo = (date) => {
  if (!date) return '—';
  const sec = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));
  if (sec < 5)   return 'just now';
  if (sec < 60)  return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  return date.toLocaleTimeString();
};

export const LiveSyncBadge = ({ lastSync, refreshing, onRefresh, testId = 'live-sync-badge' }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    const i = setInterval(() => tick((v) => v + 1), 5000);
    return () => clearInterval(i);
  }, []);
  return (
    <div data-testid={testId}
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-full
        bg-emerald-50 border border-emerald-100 text-[10px] text-emerald-700">
      <Wifi className={`w-3 h-3 ${refreshing ? 'animate-pulse' : ''}`} />
      <span className="uppercase font-semibold tracking-wider">Live</span>
      <span className="text-emerald-600/80">· synced {formatAgo(lastSync)}</span>
      {onRefresh && (
        <button onClick={onRefresh}
          disabled={refreshing}
          data-testid={`${testId}-btn`}
          title="Refresh now"
          className="ml-1 p-0.5 hover:bg-emerald-100 rounded">
          <RefreshCw className={`w-3 h-3 ${refreshing ? 'animate-spin' : ''}`} />
        </button>
      )}
    </div>
  );
};

export default LiveSyncBadge;
